import { render, staticRenderFns } from "./VaDropdown.vue?vue&type=template&id=49530135&"
import script from "./VaDropdown.vue?vue&type=script&lang=js&"
export * from "./VaDropdown.vue?vue&type=script&lang=js&"
import style0 from "./VaDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports